module.exports = __webpack_public_path__ + "img/logo-no.97a26bc.png";